<template>
  <section id="features" class="features">
    <div class="container">
      <h2>核心能力</h2>
      <div class="grid">
        <div class="card">
          <h3>双平台覆盖</h3>
          <p>原生支持 watchOS 与 Wear OS，统一 SDK 与接口抽象。</p>
        </div>
        <div class="card">
          <h3>数据与增长</h3>
          <p>内置埋点与分析看板，支持 A/B 测试与版本灰度。</p>
        </div>
        <div class="card">
          <h3>低功耗架构</h3>
          <p>表盘、卡片与后台任务深度优化，续航更持久。</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Features'
}
</script>

<style scoped>
.features {
  padding: 64px 16px;
  background: #0b1020;
  color: #d1d5db;
}
.container {
  max-width: 1100px;
  margin: 0 auto;
}
h2 {
  text-align: center;
  margin: 0 0 24px;
  color: #e5e7eb;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.card {
  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 18px;
}
.card h3 {
  margin: 0 0 8px;
  color: #f3f4f6;
}
@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 640px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>


